import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from "@ngrx/store";
import { catchError, concatMap, exhaustMap, map, mergeMap, switchMap } from "rxjs/operators";


import { FilesActions } from "../actions/files.actions";
import { SearchActions } from "../actions/search.actions";
import { Dealer } from "src/app/public/account/models/dealer.model";
import { CarBrief } from "src/app/public/car/models/car-brief.model";
import { CarCriteria } from "src/app/public/car/models/car-criteria.model";
import { Car } from "src/app/public/car/models/car.model";
import { SearchService } from "src/app/public/common/services/search.service";
import { Job } from "src/app/public/keep/models/job.model";

@Injectable()
export class SearchApiEffects{

    constructor(
        private searchService: SearchService,
        private actions$: Actions
    ){}

    // fetch preview

    fetchSearchedCarsPreview$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(SearchActions.searchPreviewCriteriaSubmit),
            mergeMap( (action) => {
                return this.searchService
                    .getSearchedCarsPreviewByCriteria(action.carCriteria)
                    .pipe( 
                        map( (carsPrev) => { 
                            console.log(carsPrev);
                            return SearchActions.searchPreviewResultsSuccess ( {carsPreview: carsPrev} );   
                        }),
                        catchError( errorResponse => {
                            console.log("Error fetching searched cars preview = "+JSON.stringify(errorResponse))
                           
                            return [
                                SearchActions.searchedCarsFetchError( {errorMessage: "Error fetching search preview for criteria =  "+errorResponse} )
                                 ]
                        })
                        )
            })
        )
    });

    fetchSearchedDealersPreview$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(SearchActions.dealersPreviewCriteriaSubmit),
            mergeMap( (action) => {
                return this.searchService
                    .getSearchedDealersPreviewByCriteria(action.dealerCriteria)
                    .pipe( 
                        map( (dealersPrev) => { 
                            console.log(dealersPrev);
                            return SearchActions.dealersPreviewResultsSuccess ( {dealersPreview: dealersPrev} );   
                        }),
                        catchError( errorResponse => {
                            console.log("Error fetching searched dealers preview = "+JSON.stringify(errorResponse))
                           
                            return [
                                SearchActions.searchedCarsFetchError( {errorMessage: "Error fetching dealers preview for criteria =  "+errorResponse} )
                                 ]
                        })
                        )
            })
        )
    });

    fetchSearchedActivitiesPreview$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(SearchActions.activitiesPreviewCriteriaSubmit),
            mergeMap( (action) => {
                return this.searchService
                    .getSearchedActivitiesPreviewByCriteria(action.jobCriteria)
                    .pipe( 
                        map( (activitiesPrev) => { 
                            console.log(activitiesPrev);
                            return SearchActions.activitiesPreviewResultsSuccess ( {activitiesPreview: activitiesPrev} );   
                        }),
                        catchError( errorResponse => {
                            console.log("Error fetching searched activities preview = "+JSON.stringify(errorResponse))
                           
                            return [
                                SearchActions.searchedCarsFetchError( {errorMessage: "Error fetching activities preview for criteria =  "+errorResponse} )
                                 ]
                        })
                        )
            })
        )
    });


    // fetch details

    fetchSearchedCars$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(SearchActions.searchCriteriaSubmit),
            mergeMap( (action) => {
                return this.searchService
                    .getSearchedCarsByCriteria(action.carCriteria)
                    .pipe( 
                        mergeMap( (cars: Car[]) => { 
                            let res: Action[] = [SearchActions.searchResultsSuccess ( {cars} )];
                            cars.forEach( car => {
                                
                                if(car.imagesFilenames != undefined && car.imagesFilenames.length > 0){
                                    car.imagesFilenames.forEach( filename => {
                                        res.push(FilesActions.fetchCarImageSubmit(( {carId: car.carId, filename: filename } )) );
                                    });
                                }
                            });
                            
                            return res;
                            
                        }),
                        catchError( errorResponse => {
                            console.log("Error fetching searched cars = "+JSON.stringify(errorResponse))
                           
                            return [
                                SearchActions.searchedCarsFetchError( {errorMessage: "Error fetching image for criteria =  "+errorResponse} )
                                 ]
                        })
                        )
            })
        )
    });

    fetchSearchedDealers$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(SearchActions.dealerCriteriaSubmit),
            mergeMap( (action) => {
                return this.searchService
                    .getSearchedDealersByCriteria(action.dealerCriteria)
                    .pipe( 
                        mergeMap( (dealers: Dealer[]) => { 
                            let res: Action[] = [SearchActions.dealerResultsSuccess ( {dealers} )];
                            dealers.forEach( dealer => {
                                /*
                                if(car.imagesFilenames != undefined && car.imagesFilenames.length > 0){
                                    car.imagesFilenames.forEach( filename => {
                                        res.push(FilesActions.fetchCarImageSubmit(( {carId: car.carId, filename: filename } )) );
                                    });
                                }
                                */
                            });
                            
                            return res;
                            
                        }),
                        catchError( errorResponse => {
                            console.log("Error fetching searched dealers = "+JSON.stringify(errorResponse))
                           
                            return [
                                SearchActions.searchedCarsFetchError( {errorMessage: "Error fetching image for criteria =  "+errorResponse} )
                                 ]
                        })
                        )
            })
        )
    });
 
    fetchSearchedActivities$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(SearchActions.jobCriteriaSubmit),
            mergeMap( (action) => {
                return this.searchService
                    .getSearchedActivitiesByCriteria(action.jobCriteria)
                    .pipe( 
                        mergeMap( (activities: Job[]) => { 
                            let res: Action[] = [SearchActions.jobResultsSuccess ( {activities} )];
                            activities.forEach( job => {
                                /*
                                if(car.imagesFilenames != undefined && car.imagesFilenames.length > 0){
                                    car.imagesFilenames.forEach( filename => {
                                        res.push(FilesActions.fetchCarImageSubmit(( {carId: car.carId, filename: filename } )) );
                                    });
                                }
                                */
                            });
                            
                            return res;
                            
                        }),
                        catchError( errorResponse => {
                            console.log("Error fetching searched activities = "+JSON.stringify(errorResponse))
                           
                            return [
                                SearchActions.searchedCarsFetchError( {errorMessage: "Error fetching image for job =  "+errorResponse} )
                                 ]
                        })
                        )
            })
        )
    });


// others

    fetchSameSellerCars$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(SearchActions.fetchSameSellerCarsSubmit),
            mergeMap( (action) => {

                let carCriteria: CarCriteria = new CarCriteria();

                carCriteria.sellerIds = [action.sellerId];
                carCriteria.businessLine = action.businessLine;

                return this.searchService
                    .getSearchedCarsByCriteria(carCriteria)
                    .pipe( 
                        mergeMap( (cars: Car[]) => { 
                            let res: Action[] = [SearchActions.fetchSameSellerCarsSuccess ( {cars: cars, businessLine: action.businessLine} )];
                            cars.forEach( car => {
                                
                                if(car.imagesFilenames != undefined && car.imagesFilenames.length > 0){
                                    car.imagesFilenames.forEach( filename => {
                                        res.push(FilesActions.fetchCarImageSubmit(( {carId: car.carId, filename: filename } )) );
                                    });
                                }
                            });
                            
                            return res;
                            
                        }),
                        catchError( errorResponse => {
                            console.log("Error fetching same seller cars = "+JSON.stringify(errorResponse))
                           
                            return [
                                SearchActions.searchedCarsFetchError( {errorMessage: "Error fetching same seller cars  =  "+errorResponse} )
                                 ]
                        })
                        )
            })
        )
    });


    fetchCarDetails$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(SearchActions.fetchCarDetailsSubmit),
            mergeMap( (action) => {
                return this.searchService
                    .getCarDetailsByIds(action.offerId, action.carId, action.businessLine)
                    .pipe( 

                        mergeMap( (cars: Car[]) => { 
                            let res: Action[] = [ SearchActions.fetchCarDetailsSuccess ({car: cars[0]}) ];

                            
                            return res;
                            
                        }),
                        catchError( errorResponse => {
                            console.log("Error fetching car details = "+JSON.stringify(errorResponse))
                           
                            return [
                                SearchActions.searchedCarsFetchError( {errorMessage: "Error fetching car details =  "+errorResponse} )
                                 ]
                        })
                        )
            })
        )
    });

    fetchCarDetailsAndImages$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(SearchActions.fetchCarDetailsAndImagesSubmit),
            mergeMap( (action) => {
                return this.searchService
                    .getCarDetailsByIds(action.offerId, action.carId, action.businessLine)
                    .pipe( 
                        // map( (cars: Car[]) => { 
                            
                        //     return SearchActions.fetchCarDetailsSuccess ({car: cars[0]});
                            
                        // }),
                        mergeMap( (cars: Car[]) => { 
                            let res: Action[] = [ SearchActions.fetchCarDetailsSuccess ({car: cars[0]}) ];
  
                            if(cars[0].imagesFilenames != undefined && cars[0].imagesFilenames.length > 0){
                                //console.log("helloo  oooo ")
                                cars[0].imagesFilenames.forEach( filename => {
                                    console.log("helloo  oooo "+filename+ " and vvvvv "+cars[0].carId)
                                    res.push(FilesActions.fetchCarImageSubmit(( {carId: cars[0].carId, filename: filename } )) );
                                });
                            }
                            
                            return res;
                            
                        }),
                        catchError( errorResponse => {
                            console.log("Error fetching car details = "+JSON.stringify(errorResponse))
                           
                            return [
                                SearchActions.searchedCarsFetchError( {errorMessage: "Error fetching car details =  "+errorResponse} )
                                 ]
                        })
                        )
            })
        )
    });

    fetchSimilarCarBriefs$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(SearchActions.fetchSimilarCarBriefsSubmit),
            mergeMap( (action) => {
                return this.searchService
                    .getSimilarCarsByCarId(action.carId, action.offerId, action.businessLine)
                    .pipe( 
                        // map( (cars: Car[]) => { 
                            
                        //     return SearchActions.fetchCarDetailsSuccess ({car: cars[0]});
                            
                        // }),
                        mergeMap( (carBriefs: CarBrief[]) => { 
                            let res: Action[] = [ SearchActions.fetchSimilarCarBriefsSuccess ({carBriefs: carBriefs}) ];
  
                            if(carBriefs != undefined && carBriefs.length > 0){
                                //console.log("helloo  oooo ")
                                carBriefs.forEach( cbrf => {
                                    //console.log("helloo  oooo "+filename)
                                    if(cbrf.imagesFilenames != undefined && cbrf.imagesFilenames.length > 0 ){
                                        res.push(FilesActions.fetchCarImageSampleSubmit(( { filename: cbrf.imagesFilenames[0] } )) );
                                    }
                                    
                                });
                            }
                            
                            
                            return res;
                            
                        }),
                        catchError( errorResponse => {
                            console.log("Error fetching car briefs = "+JSON.stringify(errorResponse))
                           
                            return [
                                SearchActions.searchedCarsFetchError( {errorMessage: "Error fetching car briefs =  "+errorResponse} )
                                 ]
                        })
                        )
            })
        )
    });

    fetchRecentCarBriefs$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(SearchActions.fetchRecentCarBriefsSubmit),
            mergeMap( (action) => {
                return this.searchService
                    .getRecentCarBriefsByCountries(action.countryCodes, action.businessLine)
                    .pipe( 

                        mergeMap( (carBriefs: CarBrief[]) => { 
                            let res: Action[] = [ SearchActions.fetchRecentCarBriefsSuccess ({carBriefs: carBriefs}) ];
  
                            if(carBriefs != undefined && carBriefs.length > 0){
                                
                                carBriefs.forEach( cbrf => {
                                    if(cbrf.imagesFilenames != undefined && cbrf.imagesFilenames.length > 0 ){
                                        res.push(FilesActions.fetchCarImageSampleSubmit(( { filename: cbrf.imagesFilenames[0] } )) );
                                    }
                                    
                                });
                            }

                            return res;
                            
                        }),
                        catchError( errorResponse => {
                            console.log("Error fetching car briefs = "+JSON.stringify(errorResponse))
                           
                            return [
                                SearchActions.searchedCarsFetchError( {errorMessage: "Error fetching car briefs =  "+errorResponse} )
                                 ]
                        })
                        )
            })
        )
    });

    fetchSameSellerCarBriefs$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(SearchActions.fetchSameSellerCarBriefsSubmit),
            mergeMap( (action) => {

                let carCriteria = new CarCriteria();
                carCriteria.sellerIds = [action.sellerId];
                carCriteria.businessLine = action.businessLine;

                return this.searchService
                    .getCarBriefsByCriteria(carCriteria)
                    .pipe( 

                        mergeMap( (carBriefs: CarBrief[]) => { 
                            let res: Action[] = [ SearchActions.fetchSameSellerCarBriefsSuccess ({carBriefs: carBriefs}) ];
  
                            if(carBriefs != undefined && carBriefs.length > 0){
                                
                                carBriefs.forEach( cbrf => {
                                    if(cbrf.imagesFilenames != undefined && cbrf.imagesFilenames.length > 0){
                                        res.push(FilesActions.fetchCarImageSampleSubmit(( { filename: cbrf.imagesFilenames[0] } )) );
                                    }
                                    
                                });
                            }

                            return res;
                            
                        }),
                        catchError( errorResponse => {
                            console.log("Error fetching car briefs = "+JSON.stringify(errorResponse))
                           
                            return [
                                SearchActions.searchedCarsFetchError( {errorMessage: "Error fetching car briefs =  "+errorResponse} )
                                 ]
                        })
                        )
            })
        )
    });

}

/**.*
 * mergeMap: DELETE - Subscribe immediately, never cancel or discard
 * concatmap: UPDATE or CREATE - Subscribe after last one finishes
 * exhaustMap: NON PARAMS GET -Discard until last one finishes
 * switchMap: PARAMS GET - Cancel the last one if it has not completed
 */